import { MatDialogConfig } from "@angular/material/dialog";

export class Common {
    public static ModalConfig: MatDialogConfig = {
      width: "100%",
      disableClose: true,
      panelClass: "modalPanel",
      backdropClass: ["non-printable"]
    };

    public RawBody(obj) {
        let result = [];
        for (let property in obj)
            result.push(encodeURIComponent(property) + ':"' + obj[property] + '"');

        return '{' + result.join(',') + '}';
    }

    public serializeObj(obj) {
        let result = [];
        for (let property in obj)
            result.push(encodeURIComponent(property) + '=' + encodeURIComponent(obj[property]));

        return result.join('&');
    }

    public static sortByField(array: Array<any>, field: string, type: string, reverse: boolean){
        let cb;
        switch (type){
          case 'date':
            cb = function(a){return Date.parse(a); };
            break;
          case 'number':
            cb = function(a){return parseFloat(a); };
            break;
          case 'string':
            cb = function(a){return (a || '').toString().toUpperCase(); };
            break;
          default :
            cb = null;
            break;
        }
        array.sort(Common.sort_by(field, reverse, cb));
      }

      public static sort_by(field, reverse, primer){

           let key = primer ?
               function(x) {return primer(x[field]); } :
               function(x) {return x[field]; };

           reverse = !reverse ? 1 : -1;

           return function (a, b) {
               return a = key(a), b = key(b), reverse * ((a > b) as any - ((b > a) as any));
             };
        }

/*         public static getYearList(totalYears?: number): number[] {
          let years:number[] = [];
          let startingYear = new Date().getFullYear() + 1;

          for(let i = 0; i < totalYears ?? 10; i++){
            years.push(startingYear-i);
          }

          return years;
        } */

        public static getYearsDropDown(startingYear: number, totalYears: number = 5): number[] {
          let years:number[] = [];
          
          for (let index = 0; index < totalYears; index++) {
            years.push(startingYear + index);
          }
          return years;
        }
}